/* Back-in-stock signup for forms rendered by snippets/singla-back-in-stock.liquid.
   Same backend as the product page form: Google Sheet webhook + Klaviyo back-in-stock API. */
(function () {
  function setMsg(msg, text, ok) {
    msg.textContent = text;
    msg.style.color = ok ? '#2a7a2a' : '#cc2222';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-singla-bis] .singla-bis__btn');
    if (!btn) return;
    var form = btn.closest('[data-singla-bis]');
    var input = form.querySelector('.singla-bis__input');
    var msg = form.querySelector('.singla-bis__msg');
    var email = input.value.trim();
    if (!email || !email.includes('@')) {
      setMsg(msg, 'Please enter a valid email.', false);
      return;
    }
    var variantId = form.dataset.variantId;

    if (form.dataset.sheetWebhook) {
      fetch(form.dataset.sheetWebhook, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          email: email,
          product: form.dataset.productTitle || '',
          size: form.dataset.variantTitle || '',
          handle: form.dataset.productHandle || '',
          variantId: variantId || ''
        })
      }).catch(function () {});
    }

    if (!form.dataset.klaviyoKey) {
      setMsg(msg, "You're on the list! We'll email you when it's back.", true);
      input.value = '';
      return;
    }
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + form.dataset.klaviyoKey, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function (res) {
      if (res.ok || res.status === 202) {
        setMsg(msg, "You're on the list! We'll email you when it's back.", true);
        input.value = '';
      } else {
        setMsg(msg, 'Something went wrong. Please try again.', false);
      }
    }).catch(function () {
      setMsg(msg, 'Something went wrong. Please try again.', false);
    });
  });
})();
